import { FetchResult, useMutation } from '@apollo/client';

import { LearningLoopSelfTrackedLearningAddDocument } from '@/store/v2';
import { AddSelfTrackedLearningToLearningLoopInput, AddSelfTrackedLearningToLearningLoopResult } from './types';

export const useLearningLoopSelfTrackedLearningAdd = (): {
  learningLoopSelfTrackedLearningAdd: (
    input: AddSelfTrackedLearningToLearningLoopInput,
  ) => Promise<FetchResult<{ learningLoopSelfTrackedLearningAdd: AddSelfTrackedLearningToLearningLoopResult }>>;
  loading: boolean;
} => {
  const [learningLoopSelfTrackedLearningAdd, { loading }] = useMutation<{
    learningLoopSelfTrackedLearningAdd: AddSelfTrackedLearningToLearningLoopResult;
  }>(LearningLoopSelfTrackedLearningAddDocument);

  return {
    learningLoopSelfTrackedLearningAdd: async (input: AddSelfTrackedLearningToLearningLoopInput) =>
      learningLoopSelfTrackedLearningAdd({
        variables: { input },
        update: (cache, { errors }) => {
          if (errors) {
            return;
          }
          cache.modify({
            id: cache.identify({ __typename: 'LearningLoop', id: input.learningLoopId }),
            fields: {
              estimatedEffort(effort) {
                return effort + input.effort;
              },
            },
          });
        },
      }),
    loading,
  };
};
